import { Channel } from 'stream-chat'
import { useMentionSuggestions as useMentionSuggestionsBase, MentionUser } from '@packages/chat'
import { getChatClient } from '../client'

export type { MentionUser }

type UseMentionSuggestionsProps = {
  channel?: Channel
  text: string
  cursorPosition: number
}

export const useMentionSuggestions = ({
  channel,
  text,
  cursorPosition,
}: UseMentionSuggestionsProps) => {
  return useMentionSuggestionsBase({
    channel,
    text,
    cursorPosition,
    getChatClient,
  })
}
